import React from 'react'
import { ComponentPropsWithRef, forwardRef } from 'react'
import classnames from 'classnames'
import { buttonRoot, disabledRoot, fluffyRoot, loadingRoot } from './Button.module.scss'

type BaseProps = ComponentPropsWithRef<'button'>

interface ButtonProps extends BaseProps {
	loading?: boolean
	fluffy?: boolean
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
	({ children, className, loading, fluffy, ...props }, ref) => {
		const rootClassName = classnames(
			buttonRoot,
			{ [loadingRoot]: loading, [disabledRoot]: props.disabled, [fluffyRoot]: !props.disabled && fluffy },
			className
		)

		return (
			<button {...props} ref={ref} className={rootClassName}>
				{children}
			</button>
		)
	}
)
